const isChristmas = false
const TopGlow = () => (
  <div
    className="spin-slow"
    css={{
      zIndex: -1,
      position: "fixed",
      left: "15%",
      /* keep translate here so rotation happens around the element center */
      transform: "translate(-50%, 0px)",
      transformOrigin: "55% 50%",
      top: -135,
      background:
        "conic-gradient(from 242deg at 50% 50%, #66ffd1 24.239592254161835deg, #00c853 270.7325005531311deg, #00f584 360deg)",

      ...(isChristmas && {
        background:
          "conic-gradient(from 242deg at 50% 50%, #99ffe0 24.239592254161835deg, #00e676 270.7325005531311deg, #00f584 360deg)",
      }),
      //

      filter: "blur(80px) brightness(1.1)",
      width: 320,
      height: 270,
    }}
  ></div>
)

export default TopGlow
